import { Component, computed, input } from '@angular/core'

import { NgIcon, provideIcons } from '@ng-icons/core'
import { lucideCircle } from '@ng-icons/lucide'
import { hlm } from '@spartan-ng/brain/core'

import { HlmIconDirective } from '@yoshu-lib/ui/ui-icon-helm/src'

import type { ClassValue } from 'clsx'

@Component({
  selector: 'hlm-menu-item-radio',
  providers: [provideIcons({ lucideCircle })],
  imports: [NgIcon, HlmIconDirective],
  template: `
    <!-- Using 0.5rem for size to mimick h-2 w-2 -->
    <ng-icon hlm size="0.5rem" class="*:*:fill-current" name="lucideCircle" />
  `,
  host: {
    '[class]': '_computedClass()'
  }
})
export class HlmMenuItemRadioComponent {
  public readonly userClass = input<ClassValue>('', { alias: 'class' })
  protected _computedClass = computed(() =>
    hlm(
      'group-[.checked]:opacity-100 opacity-0 absolute left-2 flex h-3.5 w-3.5 items-center justify-center',
      this.userClass()
    )
  )
}
